import type { FootnoteSettingsValues } from "./types";

export const NAME_MAX_LENGTH = 100;

export const DEFAULT_FOOTNOTE_SETTINGS_VALUES: FootnoteSettingsValues = {
  footnoteKind: "FREEFORM_TEXT",
  name: "",
  text: "",
  customFieldId: "",
  overrideFootnoteSymbol: false,
  footnoteSymbol: "numeric",
  suppressionRules: { groupsOperator: "and", groups: [] },
};
